import React, { useEffect } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { trackPageView } from '../util/Analytics.jsx';

const SplashPage = () => {
	useEffect(() => {
		trackPageView();
	}, []);

	const token = localStorage.getItem('token');
	if (token) {
		return <Navigate to="/app/" replace />;
	}

	return (
		<div className="pageContainer splashPage">
			<div className="pageContent splashPageContent">
				<div className="mainContent">
					<div className="text">
						<h2>Welcome to SiteWalker!</h2>
						<div className="blurb">
							The Schedule App built for job-sites.
						</div>
						<div className="sub-blurb">
							View your P6 schedule in the only app developed by schedulers for mobile.
						</div>
					</div>
					<div className="iphone-image"></div>
				</div>
				<div className="buttonContainer">
					<Link to="/signup/"><Button block bsStyle="primary">Sign Up</Button></Link>
					<Link to="/signin/"><Button block className="signInButton">Sign In</Button></Link>
				</div>
			</div>
		</div>
	);
};

export default SplashPage;
